import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap';

import { disciplinesList } from '../../../aliases';
import { CheckboxField } from '../../../blocks/edit_blocks';
import { formatDateTime } from '../../../tools/converters';
import Pocket from '../Pocket';

export default function PocketGofStreams() {
    return (
        <Pocket
            isFlex
            itemsLimit={150}
            endpoint="v2/gof.vkplay.ru/pockets/6/"
            filterFields={[
                {
                    type: 'date',
                    name: 'live',
                    label: 'Начало трансляции',
                },
                {
                    type: 'select-search',
                    name: 'disciplines',
                    label: 'Дисциплины',
                    staticSelectData: disciplinesList,
                },
            ]}
            formFields={[
                {
                    type: 'textarea',
                    name: 'title',
                    label: 'Заголовок',
                    maxLength: 128,
                    textareaRows: 3,
                    isRequired: true,
                    isMultilang: true,
                },
                {
                    type: 'input',
                    name: 'link',
                    label: 'Ссылка',
                    maxLength: 255,
                    isRequired: true,
                    isMultilang: true,
                },
                {
                    type: 'select-search',
                    name: 'disciplines',
                    label: 'Дисциплины',
                    staticSelectData: disciplinesList,
                },
                {
                    type: 'date-time',
                    name: 'start',
                    label: 'Начало показа',
                },
                {
                    type: 'date-time',
                    name: 'live',
                    label: 'Начало трансляции',
                },
                {
                    type: 'date-time',
                    name: 'finish',
                    label: 'Завершение показа',
                },
                {
                    type: 'image',
                    name: 'picture',
                    label: 'Изображение',
                    imageMinSize: '1020x574',
                    isRequired: true,
                    isMultilang: true,
                },
            ]}
            renderColumns={({ editItem, deleteItem, handleActive }) => ([
                {
                    Header: 'Заголовок',
                    sortable: false,
                    accessor: 'content.ru.title',
                    maxWidth: 440,
                    getProps: () => ({
                        style: {
                            whiteSpace: 'pre-wrap',
                        },
                    }),
                },
                {
                    Header: 'Дисциплина',
                    sortable: false,
                    accessor: 'disciplines',
                    maxWidth: 120,
                    Cell: (row) => (row.value ? row.value.map((el) => <span key={el.id}>{el.name}</span>) : ''),
                },
                {
                    Header: 'Начало показа',
                    sortable: false,
                    accessor: 'start',
                    maxWidth: 150,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: 'Начало трансляции',
                    sortable: false,
                    accessor: 'live',
                    maxWidth: 150,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: 'Завершение показа',
                    sortable: false,
                    accessor: 'finish',
                    maxWidth: 150,
                    Cell: (row) => (formatDateTime(row.value)),
                },
                {
                    Header: 'Все',
                    sortable: false,
                    accessor: 'finish',
                    maxWidth: 40,
                    Cell: (row) => (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <CheckboxField
                                    name={row.row.id}
                                    dataValue="broadcastIsEnded"
                                    label=""
                                    value={row.original.broadcastIsEnded | false}
                                    onChange={handleActive}
                                />
                            </ButtonGroup>
                        </ButtonToolbar>
                    ),
                },
                {
                    Header: '',
                    sortable: false,
                    accessor: 'id',
                    maxWidth: 70,
                    Cell: (row) => (
                        <ButtonToolbar>
                            <ButtonGroup>
                                <Button
                                    size="sm"
                                    variant="link"
                                    data-id={row.row.id}
                                    data-value={row.value}
                                    onClick={editItem}
                                >
                                    <FontAwesomeIcon id={row.row.id} data-value={row.value} icon="pencil-alt" />
                                </Button>
                                <Button
                                    size="sm"
                                    variant="link"
                                    data-id={row.row.id}
                                    data-title={row.original.title}
                                    data-value={row.value}
                                    onClick={deleteItem}
                                >
                                    <FontAwesomeIcon id={row.row.id} data-value={row.value} icon="trash" />
                                </Button>
                            </ButtonGroup>
                        </ButtonToolbar>
                    ),
                },
            ])}
        />
    );
}
